import { getCurrentScope, onScopeDispose } from "vue";

export function addScopedEventListener(target, type, listener) {
  target.addEventListener(type, listener);

  if (getCurrentScope()) {
    onScopeDispose(() => target.removeEventListener(type, listener));
  }
}
